<div class="vehicle-status-panel" [class.monitor]="isMonitorMode">
  <nz-row [nzGutter]="[16, 16]">
    <!-- ATRASADOS -->
    <nz-col nzSpan="24" nzMd="12">
      <div class="status-card overdue">
        <div class="status-card-header">
          <div class="title">
            <span class="dot dot-red"></span>
            <h3>Atrasados</h3>
            <span class="count count-red">{{ atrasado.length }}</span>
          </div>
          <button
            nz-button
            nzType="text"
            nzSize="small"
            (click)="loadData()"
            nz-tooltip
            nzTooltipTitle="Recarregar">
            <i nz-icon nzType="reload"></i>
          </button>
        </div>

        <div class="search-row">
          <nz-input-group [nzSuffix]="searchOverdueIcon">
            <input
              type="text"
              nz-input
              placeholder="Buscar placa..."
              [(ngModel)]="searchOverdue"
              (ngModelChange)="applyFilters()" />
          </nz-input-group>
          <ng-template #searchOverdueIcon><i nz-icon nzType="search"></i></ng-template>
        </div>

        <div class="status-list" [class.monitor-list]="isMonitorMode">
          <ng-container *ngIf="displayAtrasado.length > 0; else emptyOverdue">
            <div class="status-item overdue-item" *ngFor="let item of displayAtrasado">
              <div class="row-top">
                <div class="plate">
                  <span class="plate-text">{{ item.chassis }}</span>
                  <span
                    *ngIf="item.productName"
                    class="product-name"
                    nz-tooltip
                    [nzTooltipTitle]="item.productName">
                    {{ item.productName }}
                  </span>
                </div>
                <nz-tag nzColor="error" class="overdue-tag">
                  <i nz-icon nzType="warning"></i>
                  {{ item.daysOverdue }} dia(s) de atraso
                </nz-tag>
              </div>
              <div class="row-bottom">
                <span>
                  <b>Último:</b>
                  {{ item.lastChecklistAt ? (item.lastChecklistAt | date: 'dd/MM/yyyy') : 'Nunca' }}
                </span>
                <span>
                  <b>Por:</b>
                  {{ item.lastChecklistUserName || '-' }}
                </span>
                <span>
                  <b>Vencimento:</b>
                  {{ item.nextDueDate ? (item.nextDueDate | date: 'dd/MM/yyyy') : '-' }}
                </span>
                <span class="recurrence-info">{{ describeRecurrence(item) }}</span>
              </div>
            </div>
          </ng-container>
          <ng-template #emptyOverdue>
            <nz-empty
              [nzNotFoundContent]="'Nenhum veículo atrasado'"
              nzNotFoundImage="simple"></nz-empty>
          </ng-template>
        </div>
      </div>
    </nz-col>

    <!-- EM DIA -->
    <nz-col nzSpan="24" nzMd="12">
      <div class="status-card on-time">
        <div class="status-card-header">
          <div class="title">
            <span class="dot dot-green"></span>
            <h3>Em Dia</h3>
            <span class="count count-green">{{ emDia.length }}</span>
          </div>
          <button
            nz-button
            nzType="text"
            nzSize="small"
            (click)="loadData()"
            nz-tooltip
            nzTooltipTitle="Recarregar">
            <i nz-icon nzType="reload"></i>
          </button>
        </div>

        <div class="search-row">
          <nz-input-group [nzSuffix]="searchOnTimeIcon">
            <input
              type="text"
              nz-input
              placeholder="Buscar placa..."
              [(ngModel)]="searchOnTime"
              (ngModelChange)="applyFilters()" />
          </nz-input-group>
          <ng-template #searchOnTimeIcon><i nz-icon nzType="search"></i></ng-template>
        </div>

        <div class="status-list" [class.monitor-list]="isMonitorMode">
          <ng-container *ngIf="displayEmDia.length > 0; else emptyOnTime">
            <div class="status-item on-time-item" *ngFor="let item of displayEmDia">
              <div class="row-top">
                <div class="plate">
                  <span class="plate-text">{{ item.chassis }}</span>
                  <span
                    *ngIf="item.productName"
                    class="product-name"
                    nz-tooltip
                    [nzTooltipTitle]="item.productName">
                    {{ item.productName }}
                  </span>
                </div>
                <nz-tag nzColor="success" class="ok-tag">
                  <i nz-icon nzType="check-circle"></i> Em dia
                </nz-tag>
              </div>
              <div class="row-bottom">
                <span>
                  <b>Último:</b>
                  {{ item.lastChecklistAt ? (item.lastChecklistAt | date: 'dd/MM/yyyy') : 'Nunca' }}
                </span>
                <span>
                  <b>Por:</b>
                  {{ item.lastChecklistUserName || '-' }}
                </span>
                <span>
                  <b>Próximo:</b>
                  {{ item.nextDueDate ? (item.nextDueDate | date: 'dd/MM/yyyy') : '-' }}
                </span>
                <span class="recurrence-info">{{ describeRecurrence(item) }}</span>
              </div>
            </div>
          </ng-container>
          <ng-template #emptyOnTime>
            <nz-empty
              [nzNotFoundContent]="'Nenhum veículo em dia'"
              nzNotFoundImage="simple"></nz-empty>
          </ng-template>
        </div>
      </div>
    </nz-col>
  </nz-row>

  <!-- Veículos sem configuração -->
  <nz-row [nzGutter]="[16, 16]" *ngIf="semRecorrencia.length > 0" style="margin-top: 16px;">
    <nz-col nzSpan="24">
      <div class="status-card no-config">
        <div class="status-card-header">
          <div class="title">
            <span class="dot dot-gray"></span>
            <h3>Sem Recorrência Configurada</h3>
            <span class="count count-gray">{{ semRecorrencia.length }}</span>
          </div>
          <div class="search-inline">
            <nz-input-group [nzSuffix]="searchNoConfigIcon" style="width: 200px;">
              <input
                type="text"
                nz-input
                placeholder="Buscar placa..."
                [(ngModel)]="searchNoConfig"
                (ngModelChange)="applyFilters()" />
            </nz-input-group>
            <ng-template #searchNoConfigIcon><i nz-icon nzType="search"></i></ng-template>
          </div>
        </div>

        <div class="status-list compact">
          <div class="status-item no-config-item" *ngFor="let item of displaySemRecorrencia">
            <div class="row-top">
              <div class="plate">
                <span class="plate-text">{{ item.chassis }}</span>
                <span *ngIf="item.productName" class="product-name">{{ item.productName }}</span>
              </div>
              <nz-tag nzColor="default">Sem recorrência</nz-tag>
            </div>
            <div class="row-bottom">
              <span>
                <b>Último checklist:</b>
                {{ item.lastChecklistAt ? (item.lastChecklistAt | date: 'dd/MM/yyyy') : 'Nunca' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </nz-col>
  </nz-row>
</div>
